import VButton from "@/shared/ui/base-components/v-button/ui/VButton.vue";

export default VButton;
